module.exports = __webpack_public_path__ + "img/boxed-16.752a26ca.jpg";